import { Species } from '@omniafishing/core';
import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch, useSelector } from 'react-redux';
import { apiV1 } from '../../lib/api';
import { PrismicTagPrefixes } from '../../prismic';
import { fetchPrismicQasByTag, getQas } from '../../redux/pages';
import { fetchSpecies, getLoadingState, getSpeciesDetail } from '../../redux/species';
import { getIsMobile } from '../../redux/window';
import { LAKE_HERO_TAG } from '../content_list/content_list';
import { SpeciesDetailComponent } from './species_detail';

interface OwnProps {
  selectedSpecies: Species;
}

export const SpeciesDetailContainer = (props: OwnProps) => {
  const { selectedSpecies } = props;
  const dispatch = useDispatch();

  const { data } = useFrontload(`SpeciesDetailContainer:${selectedSpecies.name}`, async () => {
    const [mediaRes] = await Promise.all([
      apiV1.mediaFetch({
        per_page: 100,
        species: [selectedSpecies.name],
        exclude_tags: [LAKE_HERO_TAG],
      }),
      dispatch(fetchSpecies(selectedSpecies.url_path)),
      dispatch(fetchPrismicQasByTag(`${PrismicTagPrefixes.SPECIES}${selectedSpecies.name}`)),
    ]);

    return {
      media: mediaRes.data.data,
    };
  });

  const propsPass = {
    ...props,
    isMobile: useSelector(getIsMobile),
    loadingState: useSelector(getLoadingState),
    qas: useSelector(getQas),
    speciesDetail: useSelector(getSpeciesDetail),
    media: data?.media || [],
  };

  return <SpeciesDetailComponent {...propsPass} />;
};
